import React from "react";
import { Link } from "react-router-dom";

const FooterSection = ({ logo }) => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="fz-footer-section fz-1-footer-section">
      <div className="fz-footer-top">
        <div className="container">
          <div className="row gy-md-5 gy-4 ">
            <div className="col-xxl-12 col-lg-12 col-md-12">
              <div className="fz-footer-about fz-footer-widget">
                <div className="fz-logo fz-footer-widget__title">
                  <Link to="/">
                    <img src={logo} alt="logo" />
                  </Link>
                </div>

              </div>
            </div>




            {/* <div className="col-xxl-2 col-lg-12 col-md-6 col-6 col-xxs-12">
              <div className="fz-footer__contact-info">
                <h5 className="fz-footer-widget__title">Contact Us</h5>
                <ul>
                  <li>
                    <Link to="">
                      <i className="fa-brands fa-telegram"></i> accpp.store
                    </Link>
                  </li>
                  <li>
                    <Link to="mailto:nestearecovery@gmail.com">
                      <i className="fa-light fa-envelope-open-text"></i>
                      nestearecovery@gmail.com
                    </Link>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div className="fz-footer-bottom">
        <div className="container">
          <div className="row gy-4 align-items-center">
            <div className="col-md-6 col-12">
              <p className="fz-copyright">
                &copy;
                {currentYear} Design & Developed by <b>ACCPP.STORE</b>
              </p>
            </div>

            <div className="col-md-6 col-12">
              <div className="fz-footer-socials">
                <ul>
                  <li>
                    <Link to="https://t.me/dongduwownggg" target="_blank" rel="noopener noreferrer">
                      <i className="fa-brands fa-telegram"></i> 
                    </Link>
                    <span style ={{ marginLeft: '5px'}}>Support</span>
                  </li>


                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
